import React from "react";
import "../ui/ui.scss";

/**
 * StatusBadge — Renders a themed badge based on status string.
 *
 * Props:
 *   status    — One of: active, inactive, completed, pending, ongoing, placed, new, outline, destructive
 *   children  — Badge text (defaults to capitalized status)
 *   className — Extra class
 *   dot       — Show a pulsing dot before text (useful for "live")
 */
const StatusBadge = ({ status = "active", children, className = "", dot = false }) => {
  const label = children || status;
  return (
    <span className={`ui-badge ui-badge--${status} ${className}`}>
      {dot && <span className="ui-badge__dot" />}
      {label}
    </span>
  );
};

export default StatusBadge;
